import { OrderState } from "@/data/model/Enums";

import { trans } from "@/operator/localization/Trans";

export class OrderStateBadge {
    public static renderTo($parent: JQuery, orderState: OrderState) {
        $(this.render(orderState)).appendTo($parent);
    }

    public static render(orderState: OrderState) {
        const state = OrderState[orderState];
        return `<span class="order-state-badge order-state-${state.toLowerCase()}">${
            trans.enums.orderState[state]
        }</span>`;
    }
}
